import { apiClient, API_PRX } from '@indipia/shared';

export interface FaqCategory {
  faqCategory: string;
  categoryName: string;
  faqCount: number;
}

export interface FaqItem {
  faqId: number;
  faqQuestion: string;
  faqAnswer: string | null;
  guideUrl: string | null;
}

function mapCategory(raw: Record<string, unknown>): FaqCategory {
  return {
    faqCategory:  (raw['faqCategory']  ?? raw['faq_category'])   as string,
    categoryName: (raw['categoryName'] ?? raw['category_name'])  as string,
    faqCount:     ((raw['faqCount']    ?? raw['faq_count'] ?? 0)) as number,
  };
}

function mapItem(raw: Record<string, unknown>): FaqItem {
  return {
    faqId:       (raw['faqId']       ?? raw['faq_id'])                  as number,
    faqQuestion: (raw['faqQuestion'] ?? raw['faq_question'])            as string,
    faqAnswer:   ((raw['faqAnswer']  ?? raw['faq_answer']) ?? null)     as string | null,
    guideUrl:    ((raw['guideUrl']   ?? raw['guide_url']) ?? null)      as string | null,
  };
}

export async function fetchFaqCategories(): Promise<FaqCategory[]> {
  const res = await apiClient.get(`${API_PRX.INDIPIA}/support/faqs/categories`, {
    params: { codeGroupCode: 'ZEU_FAQ_CATEGORY' },
  });
  const list = (res.data?.data ?? []) as Record<string, unknown>[];
  return list.map(mapCategory);
}

export async function fetchFaqs(faqCategory?: string | null, faqCatgGroup?: string): Promise<FaqItem[]> {
  const params: Record<string, string> = {};
  if (faqCategory) params['faqCategory'] = faqCategory;
  if (faqCatgGroup) params['faqCatgGroup'] = faqCatgGroup;
  const res = await apiClient.get(`${API_PRX.INDIPIA}/support/faqs`, {
    params: Object.keys(params).length > 0 ? params : undefined,
  });
  const list = (res.data?.data ?? []) as Record<string, unknown>[];
  return list.map(mapItem);
}
